import { reactive } from "vue";

const STORAGE_KEY = "site-locale";

const readInitialLocale = () => {
  if (typeof window === "undefined") {
    return "zh";
  }

  const savedLocale = window.localStorage.getItem(STORAGE_KEY);
  return savedLocale === "en" ? "en" : "zh";
};

export const localeState = reactive({
  locale: readInitialLocale(),
});

export const setLocale = (locale) => {
  localeState.locale = locale === "en" ? "en" : "zh";

  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, localeState.locale);
    document.documentElement.lang = localeState.locale === "en" ? "en" : "zh-CN";
    window.dispatchEvent(
      new CustomEvent("app-locale-change", {
        detail: localeState.locale,
      })
    );
  }
};

if (typeof window !== "undefined") {
  document.documentElement.lang = localeState.locale === "en" ? "en" : "zh-CN";
}
